"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERNAL_EMAIL_SUFFIX = exports.TRIAL_PERIOD_DAYS = exports.E2E_ETHEREAL_EMAIL_SUFFIX = exports.E2E_EMAIL_SUFFIX = void 0;
exports.E2E_EMAIL_SUFFIX = 'e2e-user@vogel-vogel.com';
exports.E2E_ETHEREAL_EMAIL_SUFFIX = '@ethereal.email';
exports.TRIAL_PERIOD_DAYS = -1;
exports.INTERNAL_EMAIL_SUFFIX = '@vogel-vogel.com';
//# sourceMappingURL=users.js.map